import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PatientRelationshipEnum {
    Father = 1,
    Mother = 2,
    Daughter = 3,
    Son = 4,
    Brother = 5,
    Sister = 6,
    Adopted = 7,
    Grandfather = 8,
    Grandmother = 9,
    "Family Member" = 10
}

export class PatientRelationshipClass extends EnumWithDescription<PatientRelationshipEnum> {
    public readonly enum = PatientRelationshipEnum;
    public readonly enumName: string = "PatientRelationshipEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PatientRelationshipEnum>> = new Map([
        [
            "Father",
            {
                value: PatientRelationshipEnum.Father,
                name: "Father"
            }
        ],
        [
            "Mother",
            {
                value: PatientRelationshipEnum.Mother,
                name: "Mother"
            }
        ],
        [
            "Daughter",
            {
                value: PatientRelationshipEnum.Daughter,
                name: "Daughter"
            }
        ],
        [
            "Son",
            {
                value: PatientRelationshipEnum.Son,
                name: "Son"
            }
        ],
        [
            "Brother",
            {
                value: PatientRelationshipEnum.Brother,
                name: "Brother"
            }
        ],
        [
            "Sister",
            {
                value: PatientRelationshipEnum.Sister,
                name: "Sister"
            }
        ],
        [
            "Adopted",
            {
                value: PatientRelationshipEnum.Adopted,
                name: "Adopted"
            }
        ],
        [
            "Grandfatherd",
            {
                value: PatientRelationshipEnum.Grandfather,
                name: "Grandfather"
            }
        ],
        [
            "Grandmother",
            {
                value: PatientRelationshipEnum.Grandmother,
                name: "Grandmother"
            }
        ],
        [
            "Family Member",
            {
                value: PatientRelationshipEnum["Family Member"],
                name: "Family Member"
            }
        ]
    ]);
}

export const PatientRelationship = new PatientRelationshipClass();
